// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"a911399a","374":"93a2529c","675":"8e974021","817":"a486a066","909":"87fd3a25"}[chunkId] + ".chunk.js";
};